import React, {useEffect, useMemo, useState} from "react";
import {useDispatch} from "react-redux";
import * as userActions from "../../redux/User/actions";
import {isNullOrEmpty, isNullOrEmptyArray} from "../../utils/general";
import {columnsWidths, returnParsedColumnName} from "../../utils/columns";
import {calculateAllUniqueValues, applyFilters, initializeFilters} from "../../utils/tableUtils";
import {sortData, handleSortChange} from "../../utils/sortUtils";
import Icon from 'react-web-vector-icons';
import LoadingClock from "../../components/LoadingClock";
import RefineSearchComponents from "./SetupRow/RefineSearchComponents";
import Toaster from "../../components/Toaster";
import FilterIcon from "../../components/FilterIcon";
import useColumnFilters from '../../hooks/useColumnFilters';
import Button from "../../components/Button";
import filterIcon from '../../assets/components/filters/filter.svg';
import PopupWin from "../../components/PopupWin";
import PopupButton from "../../components/PopupButton";
import useDisplayedColumns from '../../hooks/dispalyCoulmns';
import { getDisplayFields } from '../../utils/fields/accounts.js';

const SelectAccount = props => {
	const [pageNumber, setPageNumber] = useState(1);
	const [data, setData] = useState([]); // Full data including `contact_id`
	const [fullData, setFullData] = useState([]); // Data without `contact_id`
	const [showUpdateSearchComponents, setShowUpdateSearchComponents] = useState(false);
	// const [headers, setHeaders] = useState([]);
	const [loading, setLoading] = useState(true);

	const {value, selectedVendor, saveMatch, unsaveMatch, savedMatch, segments, regions} = props;
	const dispatch = useDispatch();
	const HIDDEN_FIELDS = ['contact_id', 'account_id','original_name'];
	const [filters, setFilters] = useState({});
	const {
	displayedColumns,
	setDisplayedColumns,
	columnsFilterDisplay,
	setColumnsFilterDisplay,
	changeColumnFilterDisplay,
	isColumnDisplay,
	closeColumnsFilter,
	availebleColumns
	} = useDisplayedColumns({
	headers: getDisplayFields(selectedVendor, false,'list').map(h => h.field),
	defaultFields: getDisplayFields(selectedVendor, true,'list').map(h => h.field),
	hiddenFields: HIDDEN_FIELDS,
	storageKey: 'selectAccount'
	});

	// useEffect(() => {
	// if (headers.length && displayedColumns.length === 0) {
	// 	const visible = headers.filter(h => !HIDDEN_FIELDS.includes(h));
	// 	setDisplayedColumns(visible);
	// }
	// }, [headers,displayedColumns]);

	// Memoized footer for columns filter popup
	const columnsFilterFooter = useMemo(() => (
		<>
			<PopupButton variant="secondary" onClick={closeColumnsFilter}>Cancel</PopupButton>
		</>
	), [closeColumnsFilter]);

	const updateFilter = (value, column) => {
		const f = {...filters};
		f[column] = value;
		setFilters(f);
	};
	
		const filterField = (key, i) => {
			return (
				<td key={i} style={{width: getColumnWidth(key), display: getColumnWidth(key) === '0px' ? 'none' : ''}}>
					<input type="text" value={filters[key] || ""} onChange={e => updateFilter(e.target.value, key)} style={{width: getColumnWidth(key), outline: 'none', padding: '5px', border: '1px solid #ccc', borderRadius: '4px'}} />
				</td>
			)
		};
		// const isColumnDisplay = header => displayedColumns.includes(header);


	// Use useColumnFilters for all filter logic (no storageKey)
	const columns = useMemo(() => displayedColumns.map(key => ({ id: key })), [data]);
	const {
		filters: columnFilters,
		sortBy,
		sortOrder,
		filteredData,
		handleFilterChange,
		filterOrder,
		resetWith,
		updateData,
		uniqueValuesByColumn
	} = useColumnFilters({
		data,
		columns,
		initialState: {}
	});

	// Update data in the hook when it changes
	useEffect(() => {
		if (data) {
			updateData(data);
		}
	}, [data]);

	// Apply text input filters
	const filteredDataWithText = useMemo(() => {
		if (!filteredData || !filters) return filteredData;
		
		return filteredData.filter(row => {
			return Object.entries(filters).every(([key, value]) => {
				if (!value) return true;
				const cellValue = row[key];
				if (cellValue === undefined || cellValue === null) return false;
				return cellValue.toString().toLowerCase().includes(value.toString().toLowerCase());
			});
		});
	}, [filteredData, filters]);

	useEffect(() => {
		const load = async () => {
			if(!isNullOrEmpty(value)) {
				dispatch(userActions.loadSuggestions(selectedVendor, regions, segments, value, suggestionsLoaded));
			}
		};
		load();
	}, [dispatch, selectedVendor, segments, regions, value]);

	const expandSearch = () => {
		setLoading(true);
		const amount = 25 - data.length % 25;
		dispatch(userActions.loadMoreSimilarities(selectedVendor, value, pageNumber, amount, appendRows));
	};

	const getColumnWidth = caption => {
		if(caption === 'original_name') {
			return '0px';
		}
		return columnsWidths[caption] || '130px';
	};

	const suggestionsLoaded = suggestions => {
		if(suggestions && !isNullOrEmptyArray(suggestions.data)) {
			setFullData(suggestions.data)
			
			const displayItems = suggestions.data
			setData(displayItems);
			// setHeaders(Object.keys(displayItems[0]));
		}
		setLoading(false);
	};

	if(loading) {
		return (
			<div className="mapping-table">
				<LoadingClock />
			</div>
		)
	}

	// const orderOfPreference = ['Scaling', 'Ramping', 'Investing', 'Greenfield'];

	const doRefineSearch = async ({ type, accounts, regions, segments} ) => {
		const max = 500;

		if(accounts.length > max) {
			Toaster.showWarn(`Please upload up to ${max} accounts. (your entered ${accounts.length}).`);
			return;
		}

		setPageNumber(1);
		setData([]);
		// setHeaders([]);

		setLoading(true);
		await dispatch(userActions.searchAccounts(selectedVendor, accounts.map(str => str.trim()), regions, segments, searchLoaded));
	};

	const searchLoaded = (result) => {
		const data = result.data;
		if(data && !isNullOrEmptyArray(data)) {
			setData(data);
			// setHeaders(Object.keys(data[0]));
		}
		setLoading(false);
	};

	const appendRows = rows => {
		setLoading(false);
		setPageNumber(pageNumber+1);
		setData(data.concat(rows));
		// setHeaders(Object.keys(rows[0]));
	};

	return (
		<div>
			<div style={{height: '80px', padding: '0 30px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
				{
					isNullOrEmptyArray(data) ?
						<span>No accounts to display.</span> :
						filteredDataWithText.length === data.length ?
							<span style={{whiteSpace: 'nowrap'}}>Displaying {data.length} accounts:</span>
							:
							<span style={{whiteSpace: 'nowrap'}}>Displaying {filteredDataWithText.length} out of {data.length} accounts:</span>
				}
 				<Button type="blue" width={310} leftIcon={filterIcon} onClick={() => setColumnsFilterDisplay(true)}>Select displayed columns</Button>
				<div style={{width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center'}}>
					{
						showUpdateSearchComponents ?
							<div style={{marginRight: '30px'}}>
								<RefineSearchComponents vendor={selectedVendor} onAction={doRefineSearch} onCancel={() => setShowUpdateSearchComponents(false)} />
							</div>
							:
							<div onClick={() => setShowUpdateSearchComponents(true)} style={{display: 'flex', color: '#40A0C1', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer'}}>
								<Icon name="search1" font="AntDesign" color="#40A0C1" size={16} />
								<span>&nbsp;&nbsp;&nbsp;Update Search</span>
							</div>

					}
				</div>
			</div>

			{
				!isNullOrEmptyArray(data) &&
				<table className="mapping-table" style={{userSelect: 'none'}}>
					<thead>
					<tr>
						<th key={-1} style={{backgroundColor: '#bfe3ff59'}}>&nbsp;</th>
						{
							displayedColumns
							// .filter(key => !HIDDEN_FIELDS.includes(key))
							.map((key) => (
								<th key={key} title={key} style={{width: getColumnWidth(key), display: getColumnWidth(key) === '0px' ? 'none' : '', whiteSpace: 'nowrap', backgroundColor: key.indexOf("original") === 0 ? '#bfe3ff59' : 'transparent'}}>
									<div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
										{returnParsedColumnName(key)}
										<FilterIcon 
											column={key}
											data={data} 
											allUniqueValues={uniqueValuesByColumn[key]}
											onFilterChange={handleFilterChange} 
											filters={columnFilters}
											sortBy={sortBy}
											sortOrder={sortOrder}
											filterOrderIndex={filterOrder?.indexOf(key)}
										/>
									</div>
								</th>
							))
						}
					</tr>
					</thead>
					<tbody>
					<tr>
						<td key={-1} style={{backgroundColor: '#bfe3ff59'}}>&nbsp;</td>
						{displayedColumns.map((key, i) => filterField(key, i))}
					</tr>
					{
						filteredDataWithText && filteredDataWithText.map((row, i) => {							
							const matchFound = savedMatch.some(e => e.account_id === row.account_id);
							const matchedAccount = savedMatch.find(e => e?.key?.toLowerCase() === value?.toLowerCase())
							
							return (
								<tr key={Math.random()}>
									{matchFound ? <td key={Math.random()} onClick={() => unsaveMatch(row)} style={{backgroundColor: '#bfe3ff2e', cursor: 'pointer', userSelect: 'none'}}>
										<Icon name="close" font="AntDesign" color="red" size={18} />
									</td> :
									<td key={Math.random()} 
									onClick={() => {
										  saveMatch(row);
									  }}
									  
									style={{backgroundColor: '#bfe3ff2e', cursor: matchedAccount ? 'not-allowed' : 'pointer', pointerEvents: matchedAccount ? 'none' : 'auto', userSelect: 'none'}}>
										<Icon name="check" font="AntDesign" color={matchedAccount ? "grey" : "green"} size={18} />
									</td>}
									{
										displayedColumns
										.filter(key=> !HIDDEN_FIELDS.includes(key))
										.map((key) => (
										<td
											key={key}
											title={key}
											style={{
											width: getColumnWidth(key),
											color: 'black',
											backgroundColor: key.indexOf("original") === 0 ? '#bfe3ff2e' : 'transparent'
											}}
										>
											{row[key]}
										</td>
										))
								  }
								</tr>
							)
						})
					}
					</tbody>
				</table>
			}

			{
				isNullOrEmptyArray(filteredDataWithText) && !isNullOrEmptyArray(data) &&
				<div style={{fontSize: '20px', color: 'gray', padding: '0 30px'}}>
					No Matching Results&nbsp;&nbsp;<Icon name="meh" font="AntDesign" size={20} />
				</div>
			}
					<PopupWin
						closeOnEscape={false}
						closeOnDocumentClick={false}
						visible={columnsFilterDisplay}
						onClose={closeColumnsFilter}
						title="Select the columns you want to display"
						footer={columnsFilterFooter}>
						<div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
							{availebleColumns
							// .filter(h => !HIDDEN_FIELDS.includes(h))
							.map(header => (
								<div key={header} style={{ display: 'flex', alignItems: 'center' }}>
								<input
									type="checkbox"
									checked={isColumnDisplay(header)}
									onChange={e => changeColumnFilterDisplay(e.target.checked, header)}
								/>
								<div>{returnParsedColumnName(header)}</div>
								</div>
							))}
						</div>
					</PopupWin>

		</div>
	)
};

export default SelectAccount;
